import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { PatientAlertsApi } from './alerts/api'
import { PatientAdmissionsMewsScoreApi } from './patientAdmissionMews/api'
import { RecordedEcgSignalsApi } from './recordedEcgSignals/api'
import { RecordedEcgArrhythmiaSignalsApi } from './recordedEcgArrhythmiaSignals/api'
import reducers from './rootReducers'
import rootSaga from './rootSaga'

const sagaMiddleware = createSagaMiddleware()
const middleware = [
  sagaMiddleware,
  PatientAdmissionsMewsScoreApi.middleware,
  PatientAlertsApi.middleware,
  RecordedEcgSignalsApi.middleware,
  RecordedEcgArrhythmiaSignalsApi.middleware,
]
export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middleware),
  devTools: true,
})

sagaMiddleware.run(rootSaga)
